module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "copyright"
  }, [_c('p', {
    staticClass: "crt"
  }, [_c('a', {
    attrs: {
      "id": "pageiv"
    }
  }), _c('em', [_vm._v("Final Edition:")]), _vm._v(" Copyright © 1991 by Val McDermid"), _c('br'), _c('em', [_vm._v("Union Jack:")]), _vm._v(" Copyright © 1993 by Val McDermid")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("Cover collage photographs: woman © Mark Fearon/Arcangel; building © philopenshaw/Bigstock")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("All rights reserved. No part of this book may be reproduced in any form or by any electronic or mechanical means, including information storage and retrieval systems, without permission in writing from the publisher, except by a reviewer, who may quote brief passages in a review. Scanning, uploading, and electronic distribution of this book or the facilitation of such without the permission of the publisher is prohibited. Please purchase only authorized electronic editions, and do not participate in or encourage electronic piracy of copyrighted materials. Your support of the author’s rights is appreciated. Any member of educational institutions wishing to photocopy part or all of the work for classroom use, or anthology, should send inquiries to Grove Atlantic, 154 West 14th Street, New York, NY 10011 or "), _c('a', {
    attrs: {
      "href": "mailto:permissions@groveatlantic.com"
    }
  }, [_vm._v("permissions@groveatlantic.com")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_c('em', [_vm._v("Final Edition")]), _vm._v(" was first published in Great Britain in 1991 by The Women’s Press Ltd. Paperback edition in 2004 by HarperCollins UK. First published in the United States in 2005 by Bywater Books as "), _c('em', [_vm._v("Deadline for Murder.")])]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_c('em', [_vm._v("Union Jack")]), _vm._v(" was first published in Great Britain in 1993 by The Women’s Press Ltd."), _c('br'), _vm._v("Paperback edition in 2004 by HarperCollins UK. First published in the United States in 2005 by Bywater Books as "), _c('em', [_vm._v("Conferences Are Murder.")])]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_c('em', [_vm._v("Printed in the United States of America"), _c('br'), _vm._v("Published Simultaneously in Canada")])]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("Text Design by Norman Tuttle at Alpha Design & Composition"), _c('br'), _vm._v("This book was set in 11.5 Bembo with Charlemagne"), _c('br'), _vm._v("by Alpha Design & Composition of Pittsfield. NH.")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("First Grove Atlantic edition: March 2018")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("Library of Congress Cataloging-in-Publication data is available for this title.")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("ISBN 978-0-8021-2777-8"), _c('br'), _vm._v("eISBN 978-0-8021-6562-6")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("Grove Press"), _c('br'), _vm._v("an imprint of Grove Atlantic"), _c('br'), _vm._v("154 West 14th Street"), _c('br'), _vm._v("New York, NY 10011")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("Distributed by Publishers Group West")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_c('a', {
    attrs: {
      "href": "http://groveatlantic.com",
      "target": "_blank"
    }
  }, [_vm._v("groveatlantic.com")])]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("18 19 20 21 10 9 8 7 6 5 4 3 2 1")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9bede684","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/cop.vue
// module id = 72
// module chunks = 0